// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import api from './api'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'// element-ui的css
Vue.config.productionTip = false
Vue.prototype.$store = store
Vue.prototype.$api = api
Vue.use(ElementUI)


// setTimeout(()=>{
//   document.title='111'
// },3000)
api.user.appBaseSelect({}).then((res) => {
  if (res.code === 0) {
    document.title = res.data[0].app_name
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js